// extracted by mini-css-extract-plugin
export default {"twitterIcon":"MediaConfirmationIcon-twitterIcon-c14b57997891d1ad224e3e6e2c9c4643"};